var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{staticClass:"cc-modal",attrs:{"width":"600","footer-hide":"","title":"查看备注"},model:{value:(_vm.visibility),callback:function ($$v) {_vm.visibility=$$v},expression:"visibility"}},[(_vm.data)?_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.data)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }